var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Client Templates',
      "subTitleText": 'In order to properly implement these templates, please consult with a Project Spectrum Cyber Advisor to determine which documents are needed.<br><br>To connect with a Project Spectrum Cyber Advisor, please use the Help Desk feature located in the bottom right corner of the Project Spectrum website.'
    }
  })], 1)], 1), _c('section', {
    staticClass: "p-0"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1 px-md-5",
    attrs: {
      "id": "top-container"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4",
      "xl": "3",
      "cols": "12"
    }
  }), _c('b-col', {
    attrs: {
      "lg": "8",
      "xl": "9",
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "paragraph-text m-0"
  }, [_vm._v("Select up to 6 templates to download at a time")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4",
      "xl": "3",
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "p-3 px-4 mb-2 mb-4 search-and-filter"
  }, [_c('b-form-group', {
    staticClass: "search-and-filter-title"
  }, [_c('label', [_vm._v("Search by Title")]), _c('b-form-input', {
    attrs: {
      "placeholder": "Type and enter to search",
      "trim": ""
    },
    model: {
      value: _vm.searchTitle,
      callback: function ($$v) {
        _vm.searchTitle = $$v;
      },
      expression: "searchTitle"
    }
  })], 1), _c('b-form-group', {
    staticClass: "search-and-filter-title"
  }, [_c('label', [_vm._v("Categories:")]), _c('b-form-select', {
    attrs: {
      "options": _vm.optionsCategories
    },
    model: {
      value: _vm.searchCategory,
      callback: function ($$v) {
        _vm.searchCategory = $$v;
      },
      expression: "searchCategory"
    }
  })], 1), _c('b-form-group', {
    staticClass: "search-and-filter-title"
  }, [_c('label', [_vm._v("Levels:")]), _c('b-form-select', {
    attrs: {
      "options": _vm.optionsLevels
    },
    model: {
      value: _vm.searchLevel,
      callback: function ($$v) {
        _vm.searchLevel = $$v;
      },
      expression: "searchLevel"
    }
  })], 1), _vm.downloadArray.length > 0 ? _c('div', {
    staticClass: "w-100"
  }, [_c('b-form-group', {
    staticClass: "search-and-filter-title"
  }, [_c('label', [_vm._v(_vm._s(`Selected Templates: (${_vm.downloadArray.length})`))]), _c('ul', {
    staticClass: "m-0"
  }, _vm._l(_vm.selectedTemplates, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "selected-template-item mb-2"
    }, [_c('v-row', [_c('v-col', {
      staticClass: "pr-0 pb-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('div', {
      staticClass: "remove-template-item",
      on: {
        "click": function () {
          return _vm.selectTemplateItem(item.id);
        }
      }
    }, [_vm._v("×")])]), _c('v-col', {
      staticClass: "pr-0 pb-0",
      attrs: {
        "cols": "10"
      }
    }, [_c('div', [_vm._v(_vm._s(item.title))])])], 1)], 1);
  }), 0)]), _c('b-form-group', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    key: "",
    staticClass: "modal-btn",
    attrs: {
      "id": "input-1",
      "size": "sm",
      "disabled": _vm.downloadArray.length < 1
    },
    on: {
      "click": _vm.downloadSelectedTemplates
    }
  }, [_vm._v("Downlaod Checked")])], 1), _c('b-form-group', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    key: "",
    staticClass: "modal-btn",
    attrs: {
      "id": "input-2",
      "size": "sm"
    },
    on: {
      "click": _vm.clearSelectedTemplates
    }
  }, [_vm._v("Clear All")])], 1)], 1) : _vm._e()], 1)]), _c('b-col', {
    attrs: {
      "lg": "8",
      "xl": "9",
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "d-flex d-sm-none paragraph-small-screen-text"
  }, [_vm._v("Swipe left to view preview button")]), _vm.itemsFromSearchQuery.length > 0 ? _c('b-table', {
    attrs: {
      "fields": _vm.fields,
      "items": _vm.itemsFromSearchQuery,
      "thead-class": "table-header",
      "tbody-class": "table-body",
      "responsive": "",
      "outlined": "",
      "hover": "",
      "sticky-header": "",
      "sort-icon-left": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "update:sortBy": function ($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function ($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function ($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function ($event) {
        _vm.sortDesc = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(compare)",
      fn: function (data) {
        return [_c('div', {
          staticClass: "d-flex flex-row justify-content-center"
        }, [_c('b-form-checkbox', {
          attrs: {
            "size": "lg",
            "checked": _vm.downloadArray.includes(data.item.id),
            "value": true,
            "unchecked-value": false
          },
          on: {
            "change": function () {
              return _vm.selectTemplateItem(data.item.id);
            }
          },
          model: {
            value: _vm.form.checkbox[data.item.id],
            callback: function ($$v) {
              _vm.$set(_vm.form.checkbox, data.item.id, $$v);
            },
            expression: "form.checkbox[data.item.id]"
          }
        })], 1)];
      }
    }, {
      key: "cell(title)",
      fn: function (data) {
        return [_c('div', {
          staticClass: "template-title"
        }, [_c('p', {
          staticClass: "clipped-text m-0",
          style: {
            color: _vm.failedDownloads.length > 0 && _vm.downloadArray.includes(data.item.id) ? 'red' : '#272727'
          },
          attrs: {
            "title": data.item.title
          }
        }, [_vm._v(" " + _vm._s(data.item.title) + " ")]), _vm.failedDownloads.length > 0 && _vm.downloadArray.includes(data.item.id) ? _c('p', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(" Failed To Download   "), _c('font-awesome-icon', {
          attrs: {
            "size": "lg",
            "icon": ['fas', 'times-circle']
          }
        })], 1) : _vm._e()])];
      }
    }, {
      key: "cell(level)",
      fn: function (data) {
        var _vm$optionsLevels$fin;
        return [_c('div', {
          staticClass: "template-level"
        }, [_c('span', [_vm._v(_vm._s((_vm$optionsLevels$fin = _vm.optionsLevels.find(function (_ref) {
          var value = _ref.value;
          return value === data.item.level;
        })) === null || _vm$optionsLevels$fin === void 0 ? void 0 : _vm$optionsLevels$fin.text))])])];
      }
    }, {
      key: "cell(preview)",
      fn: function (data) {
        return [_c('div', {
          staticClass: "d-flex justify-content-center"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'client-template-item',
              query: {
                templateId: data.item.id
              }
            }
          }
        }, [_c('b-button', {
          staticClass: "btn-more",
          attrs: {
            "size": "lg"
          }
        }, [_vm._v(" Preview ")])], 1)], 1)];
      }
    }], null, false, 2564211508)
  }) : _c('div', {
    staticClass: "empty-items w-100 d-flex flex-row justify-content-center align-items-center text-center"
  }, [_vm.searchLevel !== 'level 1' ? _c('span', [_vm._v(_vm._s(`${_vm.searchLevel[0].toUpperCase()}${_vm.searchLevel.slice(1).toLowerCase()} templates will soon be available`))]) : _c('span', [_vm._v("There are no Templates available for the search query.")])])], 1)], 1)], 1)]), _c('ModalWidget', {
    attrs: {
      "id": "modal-template-issues",
      "title": "Selected Templates Limit Reached",
      "centered": "",
      "hideFooter": ""
    }
  }, [_c('p', {
    staticClass: "modal-paragraph text-center px-5",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v(" User Cannot select more than 6 templates ")]), _c('b-button', {
    key: "",
    staticClass: "modal-btn",
    attrs: {
      "slot": "row-buttons",
      "id": "input-3",
      "size": "sm"
    },
    on: {
      "click": _vm.clearSelectedTemplates
    },
    slot: "row-buttons"
  }, [_vm._v("Deselect All ")])], 1), _c('ModalWidget', {
    attrs: {
      "id": "template-download-statuses",
      "title": "Templates Downloaded",
      "centered": "",
      "hideFooter": "",
      "hideHeaderClose": _vm.isTemplatesDownloading,
      "noCloseOnBackdrop": _vm.isTemplatesDownloading,
      "closeHandler": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "px-3 pb-3",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm.isTemplatesDownloading ? _c('p', {
    staticClass: "modal-paragraph text-left",
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v(" Template document download is now in progress... ")]) : _vm._e(), _vm.successfullDownloads.length > 0 ? _c('div', [_c('p', {
    staticClass: "modal-paragraph text-left mb-1"
  }, [_vm._v(" The following templates were downloaded successfully: ")]), _c('ul', {
    staticClass: "w-100 m-0 mb-1"
  }, _vm._l(_vm.successfullDownloads, function (filename) {
    return _c('li', {
      key: filename,
      staticClass: "listitem-filename",
      staticStyle: {
        "color": "green"
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "size": "lg",
        "icon": ['fas', 'check-circle']
      }
    }), _vm._v("   " + _vm._s(filename) + " ")], 1);
  }), 0)]) : _vm._e(), _vm.failedDownloads.length > 0 ? _c('div', [_c('p', {
    staticClass: "modal-paragraph text-left mt-1"
  }, [_vm._v(" The following templates failed to download: ")]), _c('ul', {
    staticClass: "w-100 m-0 mt-1"
  }, _vm._l(_vm.failedDownloads, function (filename) {
    return _c('li', {
      key: filename,
      staticClass: "listitem-filename",
      staticStyle: {
        "color": "red"
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "size": "lg",
        "icon": ['fas', 'times-circle']
      }
    }), _vm._v("   " + _vm._s(filename) + " ")], 1);
  }), 0)]) : _vm._e()]), _c('b-button', {
    key: "",
    staticClass: "modal-btn",
    attrs: {
      "slot": "row-buttons",
      "id": "input-3",
      "size": "sm",
      "disabled": _vm.isTemplatesDownloading
    },
    on: {
      "click": _vm.closeModal
    },
    slot: "row-buttons"
  }, [_vm._v("OK ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }